import axios from '../../plugins/axios';
import { Message } from 'element-ui';

export const blogs_module = {
    state: ()=>({
        pending: false,
        loadingMore: false,
        data: {
            current_page: 1,
            data: [],
            last_page: null,
            searchedKeyword:'',
            filter:{
                status:[],
                indexed:[],
                featured:[],
            },
            allFilters:[],
        },
        message: null,
        success: null,
        error: null
    }),
    mutations: {
        fetch_blogs_request(state, loadingType){

            if(loadingType == 'new'){

                state.pending = true;

            }else if(loadingType == 'more'){

                state.loadingMore = true;

            }

        },
        fetch_blogs_success(state, payload){

            if(payload.loadData == 'new'){

                state.data.data = payload.blogs.data;

            }else if(payload.loadData == 'more'){

                state.data.data.push(...payload.blogs.data);

            }

            state.data.current_page = payload.blogs.current_page;
            state.data.last_page = payload.blogs.last_page;
            state.pending = false;
            state.loadingMore = false;
            state.success = true;
            state.error = null;
            state.message = payload.message;

        },
        fetch_blogs_failure(state, payload){

            state.data.data = [];
            state.pending = false;
            state.loadingMore = false;
            state.success = false;
            state.error = payload.error;
            state.message = payload.message;

        },
        add_blogs_list(state,payload){

            state.data.data.unshift(payload);

        },
        update_blogs_list(state,payload){

            const index = state.data.data.findIndex(x=>x.id === payload.id)
  
            if(index !== -1){

                state.data.data[index] = payload;

            }

        },
        update_blogs_status(state,payload){

            state.data.data[payload.index].isActive = payload.updatedBlog.isActive
            
        },
        delete_blogs_list(state,payload){

            state.data.data.splice(payload,1);

        },
        blogs_bulk_action(state,payload){

            if(payload.action == 'delete'){

                state.data.data = state.data.data.filter((blog)=>{

                    if(!payload.listIds.includes(blog.id)){
                        
                        return blog

                    }

                });

            }else if(payload.action == 'statusChange'){

                state.data.data.forEach((blog) =>{

                    if(payload.listIds.includes(blog.id)){

                        blog.isActive = payload.status

                    }

                });

            }else if(payload.action == 'isIndexed'){

                state.data.data.forEach((blog) => {

                    if(payload.listIds.includes(blog.id)){

                        blog.isIndexed = payload.indexed;

                    }

                });

            }

        },
        update_searched_keyword(state,payload){ 

            state.data.searchedKeyword = payload.keyword;

        },
        remove_searched_keyword(state){

            state.data.allFilters = []

            state.data.searchedKeyword = ''

        },
        update_blog_filters(state,payload){

            state.data.filter.status = payload.status
            state.data.filter.indexed = payload.indexed
            state.data.filter.featured = payload.featured

        },
        update_blog_all_filters(state,payload){
            
            state.data.allFilters = payload

        },
        remove_blog_filters(state){

            state.data.filter.status = []
            state.data.filter.featured = []
            state.data.filter.indexed = []

        },
        CLEAR_MODULE(state){

            state.pending = false;
            state.loadingMore = false;
            state.message = null;
            state.success = null;
            state.error = null;

            state.data.current_page = 1;
            state.data.data = [];
            state.data.last_page = null;
            state.data.searchedKeyword= '';
            state.data.filter = {
                status:[],
                indexed:[],
                featured:[],
            }
            state.data.allFilters = []

        }
    },
    actions:{
        async fetchStoreBlogsRequest({commit},{size, page, loadData}){
            
            commit('fetch_blogs_request',loadData);

            let status = this.state.blogs_module.data.filter.status[0];
            let indexed = this.state.blogs_module.data.filter.indexed[0];
            let featured = this.state.blogs_module.data.filter.featured[0];
            const searchedKeyword = this.state.blogs_module.data.searchedKeyword;

            try{
                let res = await axios.get('blog/all',{
                    params:{
                        search: searchedKeyword.length > 0 ? searchedKeyword : null,
                        offset: size,
                        page: page,
                        active: status ? status == 'active' ? 1 : 0 : null,
                        indexed: indexed ? indexed == 'indexed' ? 1 : 0 : null,
                        featured: featured ? featured == 'featured' ? 1 : 0 : null,
                    }
                });
                if(res.data.status_code == '1038'){

                    res.data.loadData = loadData;

                    commit('fetch_blogs_success', res.data);

                }
            }catch(ex){

                Message({
                    type: 'error',
                    showClose: true,
                    message: ex.response ? ex.response.data.message : ex.message,
                });

                commit('fetch_blogs_failure', {error: ex, message: ex});
                
            }

        }
    },
    getters: {
        blogs(state){

            return state.data.data;

        },
        isPending(state){

            return state.pending;

        },
        isLoadingMore(state){

            return state.loadingMore;

        },
        filters(state){

            return state.data.filter;

        },
        allFilters(state){

            return state.data.allFilters;

        },
        currentPage(state){

            return state.data.current_page;

        },
        lastPage(state){

            return state.data.last_page;

        },
        keyword(state){

            return state.data.searchedKeyword;

        },
        message(state){

            return state.message;
            
        },
        error:(state)=>state.error
    }
}